// src/context/UserContext.js
import React, { createContext, useState, useEffect } from "react";
import { auth, db } from "../firebase/firebaseConfig";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

// Create Context
export const UserContext = createContext();

// Provider Component
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (!firebaseUser) {
        setUser(null);
        setAuthLoading(false);
        return;
      }

      try {
        const userSnap = await getDoc(doc(db, "users", firebaseUser.uid));
        const userData = userSnap.exists() ? userSnap.data() : null;

        if (userData?.role === "admin") {
          setUser({
            id: firebaseUser.uid,
            name: userData.name || firebaseUser.displayName || "Admin",
            email: userData.email || firebaseUser.email,
            role: userData.role,
          });
        } else {
          setUser(null);
          await signOut(auth);
        }
      } catch (error) {
        console.error("Admin auth check failed:", error);
        setUser(null);
      } finally {
        setAuthLoading(false);
      }
    });

    return unsubscribe;
  }, []);

  // Save to localStorage when user changes
  useEffect(() => {
    if (user) {
      localStorage.setItem("engineercodewala_admin", JSON.stringify(user));
    } else {
      localStorage.removeItem("engineercodewala_admin");
    }
  }, [user]);
  const logout = async () => {
    try {
      await signOut(auth); // clears Firebase session
      setUser(null);
      localStorage.removeItem("engineercodewala_admin");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };
  return (
    <UserContext.Provider value={{ user, setUser, logout, authLoading }}>
      {children}
    </UserContext.Provider>
  );
};
